import { UPDATE_CHANNEL_DATA_FAILURE, UPDATE_CHANNEL_DATA_REQUEST, UPDATE_CHANNEL_DATA_RESET, UPDATE_CHANNEL_DATA_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const updateChannelDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_CHANNEL_DATA_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case UPDATE_CHANNEL_DATA_REQUEST:
            return Object.assign({}, state);
        case UPDATE_CHANNEL_DATA_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case UPDATE_CHANNEL_DATA_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default updateChannelDataReducer;
